export default __webpack_public_path__ + "static/media/LOGO-COTIC_NOVA.8ac5cfd3.svg";